module.exports = __webpack_public_path__ + "img/IAR11.6db28e9b.png";